import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Container, { ContainerProps } from '@material-ui/core/Container';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      display: 'grid',
      gridGap: theme.spacing(3),
      gridTemplateColumns: `repeat(auto-fit, minmax(327px, 1fr))`,
      gridAutoFlow: 'dense',
      padding: theme.spacing(4)
    }
  };
});

const AppCardContainer: React.FC<ContainerProps> = ({ children }) => {
  const classes = useStyles();
  return (
    <Container disableGutters maxWidth={false} className={classes.root}>
      {children}
    </Container>
  );
};

export default AppCardContainer;
